import { Button, Flex, Grid, Heading } from "@sidelinesports/fan-design-system";
import type { ComponentProps } from "react";
import { Dialog, Markdown } from "../../components/index.tsx";
import { UploadedImage } from "../../components/UploadedImage.tsx";
import { ErrorScreen, LoadingScreen } from "../../screens/index.ts";
import {
  useCurrentGameId,
  useCurrentGameQuery,
} from "./hooks/use-current-game.ts";
import { useMessageViewTracking } from "./hooks/use-message-view-tracking.ts";

export const GameWelcomeMessageDialog = (
  props: Omit<ComponentProps<typeof Dialog.Content>, "children">,
) => {
  const gameId = useCurrentGameId();
  const gameQuery = useCurrentGameQuery();

  useMessageViewTracking(gameId, { recordView: true });

  if (gameQuery.isPending) {
    return <LoadingScreen />;
  }

  if (gameQuery.isError) {
    return <ErrorScreen error={gameQuery.error} />;
  }

  const game = gameQuery.data;
  const prize = game.prizes.at(0);

  if (!prize) {
    return null;
  }

  return (
    <Dialog.Content {...props} bg="white" size="fullscreen">
      <Flex
        direction="column"
        style={{
          maxWidth: "30rem",
          minHeight: "95dvh",
          margin: "0 auto",
          width: "100%",
        }}
      >
        <Dialog.Header> </Dialog.Header>
        <Dialog.Illustration>
          <UploadedImage
            image={prize.image}
            alt=""
            maxHeight="15rem"
            maxWidth="100%"
            mx="auto"
            my="1.5rem"
            objectFit="contain"
            tracking={{
              enabled: true,
              location: "GameWelcomeMessageDialog::PrizeImage",
            }}
          />
        </Dialog.Illustration>
        <Dialog.Body>
          <Grid gap="1rem">
            <Heading level={2}>{prize.title}</Heading>
            <Markdown>{prize.text}</Markdown>
          </Grid>
        </Dialog.Body>
        <div style={{ flexGrow: 1, minHeight: "1rem" }} />
        <Dialog.Footer>
          <Dialog.Close as={Button} variant="action">
            Continue
          </Dialog.Close>
        </Dialog.Footer>
      </Flex>
    </Dialog.Content>
  );
};
